"use client";

import { useTheme } from "@/components/ThemeProvider/ThemeProvider";

interface SvgProps {
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  isFilled: boolean;
  onClick?: () => void;
}

const BookMark = ({ isFilled, width = 36, height = 36, onClick }: SvgProps) => {
  const { theme } = useTheme();

  const iconBgColor = theme === "dark" ? "#1F1F1F" : "#F4F5F7";
  const iconColor = theme === "dark" ? "#EBECF0" : "#212121";
  const fillColor = isFilled ? "#0060DD" : "transparent";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{
        cursor: "pointer",
      }}
    >
      <g clipPath="url(#clip0_48_18)">
        <path
          d="M32 0H4C1.79086 0 0 1.79086 0 4V32C0 34.2091 1.79086 36 4 36H32C34.2091 36 36 34.2091 36 32V4C36 1.79086 34.2091 0 32 0Z"
          fill={iconBgColor}
        />
        <path
          d="M12 11V26.5L18 22.5L24 26.5V11L22.5 10H13L12 11Z"
          fill={fillColor}
        />
        <path
          d="M12.1909 27.8547C11.6948 28.2117 11.0029 27.8571 11.0029 27.2459V12.25C11.0029 10.4551 12.458 9 14.2529 9H21.7513C23.5462 9 25.0013 10.4551 25.0013 12.25V27.2459C25.0013 27.8571 24.3094 28.2117 23.8133 27.8547L18.0021 23.6738L12.1909 27.8547ZM23.5013 12.25C23.5013 11.2835 22.7178 10.5 21.7513 10.5H14.2529C13.2864 10.5 12.5029 11.2835 12.5029 12.25V25.7824L17.5641 22.141C17.8258 21.9528 18.1785 21.9528 18.4401 22.141L23.5013 25.7824V12.25Z"
          fill={iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_48_18">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BookMark;
